(() => {
	let e = window.Difrax?.sectionLifecycle;
	if (!e) return;
	let t = new WeakSet(),
		n = (e) => ({
			next: e.querySelector(`[data-collection-list-next]`),
			prev: e.querySelector(`[data-collection-list-prev]`),
		}),
		r = (e) =>
			e.dataset.enableCarousel === `true` &&
			window.matchMedia(`(min-width: 750px)`).matches,
		i = (e) => {
			let t = e.querySelector(`.collection-list__slide`);
			if (!t) return e.clientWidth;
			let n = window.getComputedStyle(t),
				r =
					Number.parseFloat(n.marginInlineStart) +
					Number.parseFloat(n.marginInlineEnd);
			return t.getBoundingClientRect().width + r + 16;
		},
		a = (e) => {
			let t = e.querySelector(`[data-collection-list-viewport]`),
				{ next: i, prev: a } = n(e);
			if (!t || !i || !a) return;
			if (!r(e)) {
				(a.disabled = !0), (i.disabled = !0);
				return;
			}
			let o = t.scrollWidth - t.clientWidth,
				s = o > 1;
			(a.disabled = !s || t.scrollLeft <= 1),
				(i.disabled = !s || t.scrollLeft >= o - 1);
		},
		o = (e, t) => {
			let n = e.querySelector(`[data-collection-list-viewport]`);
			!n || !r(e) || n.scrollBy({ left: i(n) * t, behavior: `smooth` });
		},
		s = (e) => {
			let r = e.querySelector(`[data-collection-list-viewport]`);
			if (!r || t.has(r)) return;
			let { next: s, prev: c } = n(e);
			c?.addEventListener(`click`, () => o(e, -1)),
				s?.addEventListener(`click`, () => o(e, 1)),
				r.addEventListener(`scroll`, () => a(e), { passive: !0 }),
				r.addEventListener(`keydown`, (e) => {
					if (e.key !== `ArrowLeft` && e.key !== `ArrowRight`) return;
					e.preventDefault();
					let t = e.key === `ArrowRight` ? 1 : -1;
					r.scrollBy({ left: i(r) * t, behavior: `smooth` });
				}),
				t.add(r);
		};
	e.register({
		name: `collection-list`,
		selector: `[data-collection-list]`,
		init(e) {
			s(e), a(e);
		},
		update(e) {
			a(e);
		},
	});
})();
